import React from "react";
import { connect } from "react-redux";
// import { Button } from "../../../revvComponents";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MappedField from "./MapperBlock";
import { FieldsSetting } from "../../../actions";
import { DATA_PLAYFIELD } from "../../../constants";
import { REVV_LOGO, REVV_LOGO_URL } from "../../../constants/images";

const { updateFieldMappingAction } = FieldsSetting;
const { CRM_INTEGRATIONS_LOGOS } = DATA_PLAYFIELD;

const MappedFieldsList = ({
  templateId,
  // currentObject,
  currentDataSource,
  // updateFieldMapping,
  showMenuType,
  showMenu,
  searchInput,
  filterState,
  value,
  index,
  cardName,
  tableIDsWithInternalField,
  signerIDsWithInternalField,
  revvFieldIDsWithInternalField,
  metaFieldIDsWithInternalField,
  objectFieldsMapping,
  revvFieldDefs,
  cardKey,
}) => {
  // const _handleAddNewConnection = () => {
  //   const mappingID = Math.random().toString(36).substring(2, 7);
  //   const schema = {
  //     mapping: {
  //       source_fields: [],
  //     },
  //   };
  //   updateFieldMapping(mappingID, schema);
  // };
  let envName = process.env.REACT_APP_ENVIRONMENT;
  if (envName !== "PRODUCTION" && envName !== "MOJITO") {
    envName = "TEST_ENV";
  }
  const revvLogoURL = REVV_LOGO_URL[envName];
  // revvLogoURL =
  //   "https://d34fwl795uvawg.cloudfront.net/images/revv-logo-color.svg";
  let headerValue = "Form Fields";
  let mappedValue = 0;
  let totalMapping = revvFieldIDsWithInternalField;
  if (cardName === "SIGNATURE") {
    headerValue = `Signatories ${index + 1}`;
    mappedValue = 0;
    totalMapping = signerIDsWithInternalField.filter(element => {
      if (element.indexOf(value) !== -1) {
        return true;
      }
      return false;
    });
    if (Array.isArray(objectFieldsMapping) && objectFieldsMapping.length > 0) {
      objectFieldsMapping.forEach(map => {
        if (
          map.revvFieldID === value &&
          revvFieldDefs[map.revvFieldID] &&
          revvFieldDefs[map.revvFieldID].type === "SIGNATURE"
        ) {
          mappedValue += 1;
        }
      });
    }
  } else if (cardName === "TABLE") {
    headerValue = `Smart Table ${index + 1}`;
    mappedValue = 0;
    totalMapping = tableIDsWithInternalField.filter(element => {
      if (element.indexOf(value) !== -1) {
        return true;
      }
      return false;
    });
    if (Array.isArray(objectFieldsMapping) && objectFieldsMapping.length > 0) {
      objectFieldsMapping.forEach(map => {
        if (
          map.revvFieldID === value &&
          revvFieldDefs[map.revvFieldID] &&
          revvFieldDefs[map.revvFieldID].type === "TABLE_API"
        ) {
          mappedValue += 1;
        }
      });
    }
  } else if (cardName === "META_FIELD") {
    headerValue = "Meta fields";
    totalMapping = metaFieldIDsWithInternalField;
    objectFieldsMapping.forEach(map => {
      if (
        revvFieldDefs[map.revvFieldID] &&
        revvFieldDefs[map.revvFieldID].id.startsWith("METAG")
      ) {
        mappedValue += 1;
      }
    });
  } else if (
    Array.isArray(objectFieldsMapping) &&
    objectFieldsMapping.length > 0
  ) {
    objectFieldsMapping.forEach(map => {
      if (
        revvFieldDefs[map.revvFieldID] &&
        revvFieldDefs[map.revvFieldID].type !== "TABLE_API" &&
        revvFieldDefs[map.revvFieldID].type !== "SIGNATURE" &&
        !revvFieldDefs[map.revvFieldID].id.startsWith("METAG")
      ) {
        mappedValue += 1;
      }
    });
  }
  return (
    <div className="assigned-sf-fields-container">
      <div
        className="assigned-sf-fields-head"
        onClick={() => showMenu(cardName, value)}
        onKeyPress={() => showMenu(cardName, value)}
        role="button"
        tabIndex="0">
        <div className="col-md-9 assigned-sf-formfield-head">
          <span className="assigned-sf-highlight">{headerValue}</span>
        </div>

        {(currentDataSource.name === "csv" && cardName !== "TABLE") ||
        currentDataSource.name === "salesforce" ||
        currentDataSource.name === "hubspot" ? (
          <>
            <div className="col-md-3 assigned-sf-field-head">
              <span className="assigned-sf-highlight">{`${mappedValue} / ${totalMapping.length} Mapped`}</span>{" "}
            </div>
            <div
              // className="col-md-1"
              data-test="sf-show-options"
              onClick={() => showMenu(cardName, value)}
              onKeyPress={() => showMenu(cardName, value)}
              role="button"
              tabIndex="0">
              <i
                className={`ic-dropdown ${
                  showMenuType === value ? "dropdown-open" : ""
                }`}>
                <FontAwesomeIcon
                  icon={["far", "angle-down"]}
                  className="documentrecipientlist-role-icon"
                />
              </i>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
      {showMenuType === "FORM" && cardName === "FORM" && (
        <div className="assigned-sf-fields-body">
          <div className="assigned-sf-body-header">
            <div className="assigned-sf-field-logo">
              <img
                src={CRM_INTEGRATIONS_LOGOS[currentDataSource.label]}
                alt={currentDataSource.label}
              />
            </div>
            <div className="col-md-8 assigned-revv-field-logo">
              <div style={{ ...REVV_LOGO.DATA_STUDIO.STYLE }}>
                <img src={revvLogoURL} alt="Revv" width="100%" />
              </div>
            </div>
          </div>

          <MappedField
            templateId={templateId}
            searchInput={searchInput}
            filterState={filterState}
            showMenuType={showMenuType}
            value={value}
            cardName={cardName}
          />
          {/* <div className="sf-add-new-field-connection">
            <Button
              type="three"
              data-test="add-new-field-btn"
              className="add-new-field-conn"
              onClick={_handleAddNewConnection}>
              <FontAwesomeIcon icon={["fas", "plus"]} className="" />
              &nbsp; Add field mapping
            </Button>
          </div> */}
        </div>
      )}
      {showMenuType === value && cardName === "TABLE" && cardKey === value && (
        <div className="assigned-sf-fields-body">
          <div className="assigned-sf-body-header">
            <div className="assigned-sf-field-logo">
              <img
                src={CRM_INTEGRATIONS_LOGOS[currentDataSource.label]}
                alt={currentDataSource.label}
              />
            </div>
            <div className="col-md-8 assigned-revv-field-logo">
              <div style={{ ...REVV_LOGO.DATA_STUDIO.STYLE }}>
                <img src={revvLogoURL} alt="Revv" width="100%" />
              </div>
            </div>
          </div>
          <MappedField
            templateId={templateId}
            searchInput={searchInput}
            filterState={filterState}
            showMenuType={showMenuType}
            value={value}
            cardName={cardName}
          />
        </div>
      )}
      {showMenuType === value &&
        cardName === "SIGNATURE" &&
        cardKey === value && (
          <div className="assigned-sf-fields-body">
            <div className="assigned-sf-body-header">
              <div className="assigned-sf-field-logo">
                <img
                  src={CRM_INTEGRATIONS_LOGOS[currentDataSource.label]}
                  alt={currentDataSource.label}
                />
              </div>
              <div className="col-md-8 assigned-revv-field-logo">
                <div style={{ ...REVV_LOGO.DATA_STUDIO.STYLE }}>
                  <img src={revvLogoURL} alt="Revv" width="100%" />
                </div>
              </div>
            </div>
            <MappedField
              templateId={templateId}
              searchInput={searchInput}
              filterState={filterState}
              showMenuType={showMenuType}
              value={value}
              cardName={cardName}
            />
          </div>
        )}
      {showMenuType === "META_FIELD" && cardName === "META_FIELD" && (
        <div className="assigned-sf-fields-body">
          <div className="assigned-sf-body-header">
            <div className="assigned-sf-field-logo">
              <img
                src={CRM_INTEGRATIONS_LOGOS[currentDataSource.label]}
                alt={currentDataSource.label}
              />
            </div>
            <div className="col-md-8 assigned-revv-field-logo">
              <div style={{ ...REVV_LOGO.DATA_STUDIO.STYLE }}>
                <img src={revvLogoURL} alt="Revv" width="100%" />
              </div>
            </div>
          </div>
          <MappedField
            templateId={templateId}
            searchInput={searchInput}
            filterState={filterState}
            showMenuType={showMenuType}
            value={value}
            cardName={cardName}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({
  FieldsSettingStore: {
    fieldsList,
    draggedType,
    draggedFieldID,
    draggedFieldSubType,
    revvFieldDefs,
    // unusedRevvFieldIDs,
    revvFieldIDsWithInternalField,
    tableIDsWithInternalField,
    tableIdsList,
    signerIDsWithInternalField,
    metaFieldIDsWithInternalField,
    objectFieldsMapping,
    cardKey,
  },
}) => ({
  fieldsList,
  draggedType,
  draggedFieldID,
  draggedFieldSubType,
  revvFieldDefs,
  // unusedRevvFieldIDs,
  revvFieldIDsWithInternalField,
  tableIDsWithInternalField,
  tableIdsList,
  signerIDsWithInternalField,
  metaFieldIDsWithInternalField,
  objectFieldsMapping,
  cardKey,
});

const mapDispatchToProps = {
  updateFieldMapping: updateFieldMappingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MappedFieldsList);
